import { render, staticRenderFns } from "./asset.vue?vue&type=template&id=455e0dc9"
import script from "./asset.vue?vue&type=script&lang=js"
export * from "./asset.vue?vue&type=script&lang=js"
import style0 from "./asset.vue?vue&type=style&index=0&id=455e0dc9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports